var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
export default function StripFeaturedCardsCollection(props) {
    var fields = props.fields, children = props.children;
    var columnClass = fields.columns === "2" ? "two-columns" : "three-columns";
    return (React.createElement("div", __assign({ className: "strip spa-featured-card-collection "
            + fields.backgroundColor
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("div", { className: "featured-list-cards " + ("text-" + fields.textSize) + " " + columnClass }, children.map(function (child) { return (React.createElement("div", { className: "featured-card "
                            + (child.fields.overlay ? "with-overlay" : ""), key: child.id },
                        React.createElement("a", { href: child.fields.link.length ? child.fields.link : "#", title: child.fields.linkTitle || child.name },
                            React.createElement("div", { className: "img-container" },
                                React.createElement("img", { className: "img-fluid", src: child.fields.image, title: child.fields.image_title, alt: child.fields.image_description })),
                            React.createElement("div", { className: "overlay d-flex align-items-end" },
                                React.createElement("div", { className: "info-content" },
                                    child.fields.title &&
                                        React.createElement("div", { className: "title mb-0", dangerouslySetInnerHTML: { __html: child.fields.title } }),
                                    child.fields.label &&
                                        React.createElement("div", { className: "label mb-0", dangerouslySetInnerHTML: { __html: child.fields.label } })))))); })))))));
}
